"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderReactReduxAndTranslation = void 0;
var reduxAndTranslation_renderer_1 = require("./reduxAndTranslation.renderer");
Object.defineProperty(exports, "renderReactReduxAndTranslation", { enumerable: true, get: function () { return reduxAndTranslation_renderer_1.renderReactReduxAndTranslation; } });
//# sourceMappingURL=index.js.map